import React from "react";
import { useTranslation } from "react-i18next";
import { TIME_BLOCKS } from "../../utils/availabilityFilter";

function TimeBlockFilter({ selectedBlock = "all", setSelectedBlock }) {
  const { t } = useTranslation();

  const handleBlockClick = (blockId) => {
    // Single choice selection: if clicking the active block, reset to "all"
    if (selectedBlock === blockId && blockId !== "all") {
      setSelectedBlock("all");
    } else {
      setSelectedBlock(blockId);
    }
  };

  const isFilterActive = selectedBlock && selectedBlock !== "all";

  return (
    <div className="mt-6 mb-4 max-w-4xl mx-auto text-center">
      <div className="flex items-center justify-center gap-2 mb-3">
        <h3 className="text-base md:text-lg font-bold text-[var(--text)]">
          {t("time_filter.preferred_time")}
        </h3>
        {isFilterActive && (
          <button
            type="button"
            onClick={() => setSelectedBlock("all")}
            className="text-xs font-semibold px-2.5 py-1 rounded-full bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 transition-all flex items-center gap-1 cursor-pointer"
            title={t("time_filter.clear_filter")}
          >
            <span>✕</span> {t("time_filter.clear_filter")}
          </button>
        )}
      </div>
      <div className="bg-white border border-[var(--border)] rounded-full p-2 flex flex-wrap gap-2 justify-center">
        {TIME_BLOCKS.map((block) => {
          const isSelected = selectedBlock ? selectedBlock === block.id : block.id === "all";
          return (
            <button
              key={block.id}
              type="button"
              onClick={() => handleBlockClick(block.id)}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition-all ${
                isSelected
                  ? "bg-[var(--brand)] text-white shadow-sm"
                  : "bg-transparent text-[var(--muted)] hover:bg-[var(--brand)] hover:text-white"
              }`}
            >
              {t(block.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TimeBlockFilter;
